import { forEach } from 'lodash'
import ActionTypes from '@constants/action_types.js'
import PhotoPollQueue from '@utils/photo_poll_queue.js'

export function receiveEntities(normalizedEntities) {
  return dispatch => {
    dispatch({
      type: ActionTypes.RECEIVE_ENTITIES,
      payload: normalizedEntities,
    })
    pollForPhotos(normalizedEntities, dispatch)
  }
}

export function removeEntity(entityId, entityType, parentEntityId = null, parentEntityType = null) {
  return {
    type: ActionTypes.REMOVE_ENTITY,
    payload: {
      entityId,
      entityType,
      parentEntityId, // optional
      parentEntityType, // optional
    },
  }
}

function pollForPhotos(normalizedEntities, dispatch) {
  if (normalizedEntities.hasOwnProperty('photo')) {
    const { photo } = normalizedEntities
    PhotoPollQueue.startPollingIfNeeded(photo, dispatch)
  }
  if (normalizedEntities.hasOwnProperty('photos')) {
    const { photos } = normalizedEntities
    forEach(photos, photo => {
      PhotoPollQueue.startPollingIfNeeded(photo, dispatch)
    })
  }
}
